module.exports = "<button class=\"badge badge-primary badge-pill btn btn-sm btn-primary\" alt=\"Buy Tokens\" \n  title=\"Buy Tokens\" (click)=\"buyItem($event)\" [disabled]=\"buying\">Buy</button> "


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/buy-item-button/buy-item-button.component.html
// module id = ./src/app/shared/buy-item-button/buy-item-button.component.html
// module chunks = main